<section class="ced-conf" aria-label="Conferência física">
  <div class="ced-conf-titulo">
    <h3>Conferência física</h3>
    <span class="status-badge badge-vermelho ced-conf-pilula">
      <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>CONFERÊNCIA FÍSICA
    </span>
  </div>
  <p class="ced-conf-apoio">Recebimento (volumes) e conferência de itens são ações independentes — faça em qualquer ordem.</p>

  @if (!situacao && motivoSituacao) {
  <app-alert-card type="warning" icon="lock" title="Conferência indisponível.">{{ motivoSituacao }}</app-alert-card>
  }

  @if (situacao?.isBloqueada) {
  <app-alert-card type="warning" icon="lock" title="Conferência bloqueada.">
    {{ situacao?.motivoBloqueio }} Use Resolver associação no bloco da nota acima.
  </app-alert-card>
  }

  <div class="ced-conf-acoes">
    @for (acaoCartao of acoes; track acaoCartao) {
    <span class="ced-conf-acao-wrap" [matTooltip]="motivoBloqueio(acaoCartao)" [matTooltipDisabled]="!motivoBloqueio(acaoCartao)">
      <button type="button" class="ced-conf-acao" [class.ced-conf-acao--reabrir]="podeReabrir(acaoCartao)"
        [disabled]="isDesabilitado(acaoCartao)" (click)="abrir(acaoCartao)"
        [attr.aria-label]="acaoCartao === acao.ConferirVolumes ? 'Receber mercadorias' : 'Conferir itens'">
        <span class="ced-conf-acao-topo">
          <mat-icon class="material-symbols-outlined ced-conf-acao-icone">
            {{ acaoCartao === acao.ConferirVolumes ? 'local_shipping' : 'checklist' }}
          </mat-icon>
          <b>{{ acaoCartao === acao.ConferirVolumes ? 'Receber mercadorias' : 'Conferir itens' }}</b>
          @if (isCega(acaoCartao)) {
          <span class="status-badge badge-oliva ced-conf-cega">
            <mat-icon class="material-symbols-outlined">visibility_off</mat-icon>CEGA
          </span>
          }
          @if (abrindo === acaoCartao) { <mat-spinner diameter="16" class="ced-conf-spinner"></mat-spinner> }
        </span>
        @if (situacao) {
        <span class="ced-conf-selos">
          <span class="status-badge badge-dot ced-conf-status" [ngClass]="classeStatus(acaoCartao)">{{ rotuloStatus(acaoCartao) }}</span>
          @if (quantidadeDivergencias(acaoCartao); as qtd) {
          <span class="status-badge badge-vermelho ced-conf-status">
            <mat-icon class="material-symbols-outlined">report</mat-icon>{{ qtd }} {{ qtd === 1 ? 'divergência' : 'divergências' }}
          </span>
          }
        </span>
        }
      </button>
      @if (podeReabrir(acaoCartao)) {
      <!-- Irmão do cartão (não dentro dele), posicionado sobre o canto: o clique não abre a visualização concluída. -->
      <button mat-stroked-button type="button" class="btn-secondary btn-spinner ced-conf-reabrir"
        [class.btn-loading]="reabrindo === acaoCartao"
        [attr.aria-label]="reabrindo === acaoCartao ? 'Reabrindo contagem' : 'Reabrir contagem'"
        [disabled]="carregandoSituacao || abrindo !== null || reabrindo !== null" (click)="reabrir(acaoCartao)">
        <mat-icon class="material-symbols-outlined">restart_alt</mat-icon>
        Reabrir contagem
        @if (reabrindo === acaoCartao) { <mat-spinner diameter="20"></mat-spinner> }
      </button>
      }
    </span>
    }
  </div>

  @if (situacao?.problemas?.length) {
  <div class="ced-conf-problemas">
    <div class="ced-conf-problemas-titulo">Problemas registrados</div>
    @for (problema of situacao!.problemas; track problema.idConferenciaProblema) {
    <div class="ced-conf-problema">
      <mat-icon class="material-symbols-outlined ced-conf-problema-icone">report</mat-icon>
      <div class="ced-conf-problema-corpo">
        <div class="ced-conf-problema-topo">
          <span class="ced-conf-problema-tipo">{{ rotuloTipoProblema(problema.idTipoDivergenciaCompra) }}</span>
          @if (problema.quantidade != null) { <span>· qtd. {{ problema.quantidade | number: '1.0-4' }}</span> }
          <span class="ced-conf-problema-data">{{ problema.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
        @if (nomeItemProblema(problema.idConferenciaItem)) {
        <div class="ced-conf-problema-texto">Item: {{ nomeItemProblema(problema.idConferenciaItem) }}</div>
        }
        @if (problema.referencia) { <div class="ced-conf-problema-texto">Referência: {{ problema.referencia }}</div> }
        @if (problema.descricao) { <div class="ced-conf-problema-texto">{{ problema.descricao }}</div> }
      </div>
    </div>
    }
  </div>
  }
</section>
